import React, { useCallback } from 'react';
import { DataTable } from 'components/data-table';
import { format0 } from 'utils/number';
import { useTcTableWellsQuery } from './hooks';
import { TypeCurveWellRow } from './types';
import style from './type-curve-wells-table.module.scss';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from 'components/accordion/accordion';
import { TypeCurveHeader } from 'types/api-responses';
import { typeCurveWellsTableColumns } from './type-curve-wells-table-column';

interface TypeCurveWellsTableProps {
  typeCurveHeader: TypeCurveHeader;
}

export const TypeCurveWellsTable: React.FC<TypeCurveWellsTableProps> = ({
  typeCurveHeader,
}) => {
  const { wells, totalCount, isLoading, error, loadData } =
    useTcTableWellsQuery(typeCurveHeader);

  const getRowId = useCallback((row: TypeCurveWellRow) => row.uwi, []);

  return (
    <Accordion defaultExpanded className={style.accordionRoot}>
      <AccordionSummary>
        <h2 className={style.typeCurveWellsTitle}>
          Type Curve Wells ({format0(totalCount)})
        </h2>
      </AccordionSummary>
      <AccordionDetails className={style.accordionDetails}>
        <div className={style.tableContainer}>
          <DataTable<TypeCurveWellRow>
            data={wells}
            columns={typeCurveWellsTableColumns}
            getRowId={getRowId}
            isLoading={isLoading}
            error={error}
            persistenceKey="type-curve-wells-table-2"
            scroll={{ mode: 'paginated', serverDriven: true, totalCount }}
            onPaginationChange={loadData}
            onSortChange={loadData}
            onFilterChange={loadData}
            onGlobalSearchChange={loadData}
            config={{
              columnResizing: true,
              columnReordering: true,
              columnPinning: true,
              sorting: true,
              columnVisibility: true,
              globalSearch: true,
              columnFilters: false,
              export: true,
            }}
            searchPlaceholder="Search wells..."
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
